export default "__VITE_ASSET__C0kAx4hF__"